import React from 'react';
import '../style/KgWeightSelector.scss';

/**
 * Component for selecting weight units for kg products
 * @param {Object} props
 * @param {number} props.selectedWeight - Currently selected weight (0.1, 0.5, 1)
 * @param {Function} props.onWeightChange - Callback when weight changes
 */
const KgWeightSelector = ({ selectedWeight, onWeightChange }) =>
{
    const weights = [
        { value: 0.1, label: '100g' },
        { value: 0.5, label: '500g' },
        { value: 1, label: '1kg' }
    ];

    return (
        <div className="kg-weight-selector">
            {weights.map((weight) => (
                <button
                    key={weight.value}
                    type="button"
                    className={`weight-btn ${selectedWeight === weight.value ? 'active' : ''}`}
                    onClick={() => onWeightChange(weight.value)}
                >
                    {weight.label}
                </button>
            ))}
        </div>
    );
};

export default KgWeightSelector;
